import { render } from "./OrgExcecutiveReport.vue?vue&type=template&id=70bc4404&scoped=true"
import script from "./OrgExcecutiveReport.vue?vue&type=script&lang=js"
export * from "./OrgExcecutiveReport.vue?vue&type=script&lang=js"

import "./OrgExcecutiveReport.vue?vue&type=style&index=0&id=70bc4404&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bc4404"]])

export default __exports__